module.exports = __webpack_public_path__ + "img/infinity8ex_icon.add9f0b4.png";